import { instance } from './index';
import { useQuery, useMutation, useQueryClient, QueryClient, QueryClientProvider } from 'react-query';

const contextPath = '/common';
const queryName = 'COMMON';

export const useGetNotices = (param) => {
    const queryClient = useQueryClient();
    return useQuery([`${queryName}_NOTICES`], () => getNotices(param),{onSuccess:()=>queryClient.setQueryData(['MODAL_INFO'],{show:true})});
}

const getNotices = async (param) => {
    const retVal = await instance.get(contextPath+'/notices', {params:param})
                                    .then((res)=>{
                                        return res.data;
                                    })
                                    .catch((err)=>{
                                        return err;
                                    })
    return retVal;
}

export const useGetMenuStatus = () => {
    return useQuery(['MENU_STATUS'],()=>true,{initialData:true})
}

export const useGetNaviInfo = () => {
    return useQuery(['NAVI_INFO'],()=>[])
}

export const useGetDataTime = () => {
    const queryClient = useQueryClient();
    return useQuery(['REFRESH_TIME'],() => queryClient.getQueryData(['REFRESH_TIME']));
}


export const useGetTargetCodeList = (param) => {
    const queryClient = useQueryClient();
    return useQuery([`${queryName}_CODE_LIST`], () => getTargetCodeList(param));
}

const getTargetCodeList = async (param) => {
    const retVal = await instance.get(contextPath+'/getTargetCodeList/'+param, null)
                                    .then((res)=>{
                                        return res.data;
                                    })
                                    .catch((err)=>{
                                        return err;
                                    })
    return retVal;
}